import React, {Component} from 'react';
import cookie from '../../helper/cookie';
import Pubnub from '../../helper/Pubnub';
import AddCustomerMutation from '../../mutations/AddCustomerMutation';
import Relay from 'react-relay';

export default class ChatBox extends Component {
 constructor(props) {
   super(props);

   this.state = {
     clicked:true
   }

   this.chatTabClicked = this.chatTabClicked.bind(this);
   this.teamTabClicked = this.teamTabClicked.bind(this);

 }
 chatTabClicked(event){
     this.setState({clicked:true});
 }
 teamTabClicked(event){
     this.setState({clicked:false});
 }
 render() {
     var st={
         nopad:{
             padding:'0px',

         },
         chatTab:{
             padding:'0px',
             backgroundColor:'#ffffff ',
             cursor:'pointer',
         },
        teamTab:{
             padding:'0px',
             backgroundColor:'#ffffff ',
             cursor:'pointer',
         },
         bg1:{
             backgroundColor:'lavender',
         },
         bg2:{
             backgroundColor:'lavenderblush',
         },
     };
     var clstrChat="col-md-6 col-xs-6";
     var clstrTeam="col-md-6 col-xs-6";
     var content;
     if(this.state.clicked)
     {
         clstrChat=clstrChat+" active";
         st.teamTab.backgroundColor='#f7f7f7 ';
         content=<ChatMessageBox isAgentSide={this.props.isAgentSide} data={this.props.data} />
     }
     else
     {
         clstrTeam=clstrTeam+" active";
         st.chatTab.backgroundColor='#f7f7f7 ';
         content=<TeamBox isAgentSide={this.props.isAgentSide} data={this.props.data} />
     }
   return (
             <div className="panel panel-default col-md-12" style={st.nopad}>
                 <ul className="panel-heading nav nav-tabs" style={st.nopad}>
                      <li className={clstrChat} style={st.chatTab} onClick={this.chatTabClicked}><a >TEAM CHAT</a></li>
                      <li className={clstrTeam} style={st.teamTab} onClick={this.teamTabClicked}><a >PROJECT TEAM</a></li>
                  </ul>
                    {content}
             </div>
   );
 }
}
class ChatMessageBox extends Component {
  constructor(props){
    super(props);

    var date = new Date();
    date = String(date).split(" ")[1] + ' ' + String(date).split(" ")[2] + ', ' + String(date).split(" ")[4].split(":")[0] + ':' + String(date).split(" ")[4].split(":")[1];

    this.state={
      messagesar:[ 
      {
        msg:"Hi, Welcome To Surveymate. I am your survey expert for this project. How may I assist you ?",
        type:"received", 
        username:this.props.data.agent.agentName,
        id: this.props.data.customerId, 
        time:date,
        agentname:"kishan patel"
      }
      ]
    };
    this.onkeyPressed=this.onkeyPressed.bind(this);
    this.receive=this.receive.bind(this);
    this.history=this.history.bind(this);
  }
  receive(m){
    // console.log("here",m);
    if (cookie.get('userId') != m.id) {
      m.type = "received"
      this.setState({messagear:this.state.messagesar.push(m)});
    }
  }
  history(m){
    var i;
    for (i = 0; i < m[0].length; i++) {
      m[0][i].agentname = this.props.data.agentName;
      if (m[0][i].id != cookie.get('userId')) {
        m[0][i].type = "received"
      }
      this.setState({messagear:this.state.messagesar.push(m[0][i])});
    }

  }
  componentDidMount()
  {
    this.refs.scbar.scrollTop=this.refs.scbar.scrollHeight;
    var self = this;

    Pubnub.history({
     channel: this.props.data.pid,
     callback: function(m) {
        self.history(m);
     },
     count: 100, // 100 is the default
     reverse: false // false is the default
    });
    
    Pubnub.subscribe({
        channel: self.props.data.pid,
        message: function(m) {
          self.receive(m);
          // self.setState(self.state.messagesar.push(m));
        }
    });
  }
  componentDidUpdate()
  {
    this.refs.scbar.scrollTop=this.refs.scbar.scrollHeight;;
  }
  onkeyPressed(event)
  {

    //document.getElementById('ms1234').scrollTop=document.getElementById('ms1234').scrollHeight;
    var key=event.keyCode;
    if(key==13 && (document.getElementById('textmessage').value).trim()!==""){
      
      var date = new Date();
      date = String(date).split(" ")[1] + ' ' + String(date).split(" ")[2] + ', ' + String(date).split(" ")[4].split(":")[0] + ':' + String(date).split(" ")[4].split(":")[1];

      var json = {
        msg:(document.getElementById('textmessage').value).trim(),
        username:this.props.data.customerName,
        id: this.props.data.customerId,
        type:"sent",
        time:date
      };

      Pubnub.publish({
          channel: this.props.data.pid,
          message: json
      });

      document.getElementById('textmessage').value = null;

      this.setState({messagear:this.state.messagesar.push(json)});


      //document.getElementById('ms1234').scrollTop=document.getElementById('ms1234').scrollHeight;

      if(event.preventDefault)
        event.preventDefault();


      return false;
    }
  }
    render() {
        var st={
            chatMessageBox:{
                height:'320px',
                overflow: 'auto',
            },
            inputTextArea:{
                resize: 'none',
            },
        };

        return(

            <div>
                <div className="panel-body scrollbar" id="style-1" ref="scbar"style={st.chatMessageBox}>

                  {this.state.messagesar.map(function(i){
                    return (<Mess data={i} isAgentSide={this.props.isAgentSide} />);
                  }.bind(this)
                )}


                  </div>
                  <textarea className="form-control" rows="2" style={st.inputTextArea} onKeyDown={this.onkeyPressed} id="textmessage" placeholder="Send a message to your Surveymate">

                  </textarea>
              </div>
        );
    }
}
class TeamBox extends Component {
    constructor(props)
    {
      super(props);
      if(this.props.isAgentSide=="false"){
        this.state={em:true,clk:false,invite:false}
        this.inviteClckd=this.inviteClckd.bind(this);
        this.validateEmail=this.validateEmail.bind(this);
      }
    }
    validateEmail() {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
         this.setState({em:re.test(this.refs.email.value.trim())});
         console.log(this.state.em);
    }
    inviteClckd()
    {
      this.setState({clk:true});
      Relay.Store.update(new AddCustomerMutation({
          userId: this.props.data.customerId,
          conversationId: this.props.data.pid,
          email: this.refs.email.value,
          name: this.refs.email.value.split("@")[0]
        }), {
          onFailure: (t) => {
            console.log('onFailure of AddConversationMutation', t);
          },
          onSuccess: (t) => {
            console.log('onSuccess of AddConversationMutation', t);
            this.setState({invite:true});
            // window.location.href='/#/projects/' + cookie.get('userId');
          }
      });
    }
    render() {
      var eclass;
      var st={
        teamBox:{
          height:'423px',
          overflow: 'auto',
        },
        noborder:{
          border:'none',
          backgroundColor:'#fafafa',
        },
        img:{
          top:0,
          padding:0,
          marginLeft:5,
        },
        scrollable:{
          overflow:'auto',
          height:'150px'
        },
        in:{
          height: "56px",
          borderRadius: "5px",
        },
        bttn_attri:{
          height:"56px",
          backgroundColor:"#1a84eb",
          marginTop:"23px",
          marginLeft:"-5px"

        },
        tex_:{
          fontSize:12,
          color: "#ffffff",
          letterSpacing: 0.3,

        },
      };
      if(this.props.isAgentSide=="true")
      {
        return(
            <div>
              <div className="panel-body" style={st.teamBox}>
                  <div style={{backgroundColor:"#fafafa"}} className="small text-muted">
                    <u><strong>PROJECT TEAM</strong></u>
                  </div>
                  <ul className="list-group" style={st.scrollable} id="style-1">
                    {
                      this.state.projectMembers.map(
                        function(row){
                          return(
                            <li className="list-group-item" style={st.noborder}>
                              <div className="row">
                                <img className="img-responsive img-circle col-md-1" style={st.img} id="usrimg" src={row.customerimg} width="30px" height="30px"/>
                                <span className="col-md-10 text-left">{row.customeremail}</span>
                              </div>
                            </li>
                          );
                        }
                      )
                    }
                  </ul>

                  <div style={{backgroundColor:"#fafafa"}} className="small text-muted">
                    <u><strong>AGENTS</strong></u>
                  </div>
                  <ul className="list-group" style={st.scrollable} id="style-1">
                    {
                      this.state.agents.map(
                        function(row){
                          return(
                            <li className="list-group-item" style={st.noborder}>
                              <div className="row">
                                <img className="img-responsive img-circle col-md-1" style={st.img} id="usrimg" src={row.agentimg} width="30px" height="30px"/>
                                <span className="col-md-10 text-left">{row.agentemail}</span>
                              </div>
                            </li>
                          );
                        }
                      )
                    }
                  </ul>

              </div>
            </div>
        );
      }
      else {
        var cname,mess="";

        if(this.state.clk) {
          if(this.state.em)
          {
            mess="";
          }
          else {
            mess="Enter valid e-mail";
          }
        }
        var success=""
        if(this.state.invite){
          success=<div className="text-success">Invited Successfully</div>
        }
        return(
            <div>
              <div className="panel-body" style={st.teamBox}>
                <div className="small text-muted underline">
                  <u>YOUR TEAM</u>
                </div>
                <ul className="list-group" style={st.scrollable} id="style-1">
                  {
                    this.props.data.projectMembers.map(
                      function(row){
                        return(
                          <li className="list-group-item" style={st.noborder}>
                            <div className="row">
                              <img className="img-responsive img-circle col-md-1" style={st.img} id="usrimg" src={row.customerimg} width="30px" height="30px"/>
                              <span className="col-md-10 text-left">{row.customeremail}</span>
                            </div>
                          </li>
                        );

                     }
                    )
                  }
                </ul>
                <p className="text-danger">{mess}</p>
                    <div className="row">
                      {success}
                      <div className="col-md-8">
                          <form role="form">
                              <label htmlFor="usr">INVITE TEAM MEMBER</label>

                              <input type="text" className="form-control" id="usr" style={st.in} placeholder="Enter E-mail address" ref="email" onChange={this.validateEmail}/>
                          </form>
                      </div>
                      <button type="button" className="btn btn-primary btn-lg col-md-4" style={st.bttn_attri} onClick={this.inviteClckd}><small>INVITE</small>
                      </button>
                    </div>
                    <div className="row" style={{height:"1px",opacity:0.1,border:"solid 1px #171717"}}></div>
                    <div className="small text-muted" style={{marginTop:"15px",marginLeft:"15px"}}>
                      <u><small><strong>SURVEYMATE TEAM</strong></small></u>
                    </div>
                    <br />
                      <img className="img-responsive img-circle col-md-1" style={st.img} src={this.props.data.agent.agentImage} width="30px" height="30px"/>
                      <span className="col-md-10 text-left">
                          <h5><strong>{this.props.data.agent.agentName}</strong></h5>
                          <p className="text-muted"><small><strong><u>SURVEY EXPERT</u></strong></small></p>
                      </span>


                  </div>

            </div>
        );
      }
    }
}
class  Mess extends Component {
  constructor(props){
    super(props);

  }

  render(){
    var cname,leftim,rightim,rowpull;
    var st={
          mwrap:{
            wordWrap:"break-word",
          },
          msgcolor:{
            backgroundColor:"#f1f1f1",
            color:"black",
          }
    }
    var agentname="";
    if(this.props.data.type=="sent")
    {
      rowpull="col-md-11 col-sm-11 col-xs-11 pull-right";
      cname="col-md-8 col-sm-8 col-xs-8 alert alert-success ";
      rightim=<Img leftpos="-25px" />;
      leftim=<div className="col-md- col-sm-2 col-xs-2"></div>;
      if(this.props.isAgentSide=="true")
      {
        agentname=" • "+this.props.data.agentname;
      }
    }
    else {
      rowpull="col-md-11 col-sm-11 col-xs-11 pull-left"
      cname="col-md-8 col-sm-8 col-xs-8 alert alert-info ";
      st.msgcolor.backgroundColor="#cce6ff";
      rightim=<div className="col-md-2 col-sm-2 col-xs-2"></div>;
      leftim=<Img leftpos="25px"/>;
    }
    return(
        <div className="row">
          <div className={rowpull}>
            {leftim}
            <div className={cname} style={st.msgcolor} >
              <small className="text-muted">{this.props.data.username}</small>
              <p style={st.mwrap}>{this.props.data.msg}</p>
              <small className="text-muted">{this.props.data.time}{agentname}</small>
            </div>
            {rightim}
          </div>
        </div>
    );
  }
}
class Img extends Component{
  render(){
    var st={
        imgpadd:{
          position:'relative',
          top:0,
        }
      };
    return(
      <img className="img-responsive img-circle col-sm-2 col-md-2 col-xs-2" id="usrimg" style={st.imgpadd} src="http://dndw32r4edmw5.cloudfront.net/avatar/Male.png" max-width="25px" max-height="25px" width="25px" height="25 px"/>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/clientDashboard/chatbox.js
 **/